<template>
    <div class="carriers">
        <div class="row">
            <div class="col">
                <h3>{{ translations['Carrier'] }} <span class="change-carrier" v-if="selectedCarrier" @click="unsetCarrierAndPayment">{{ translations['change'] }}</span></h3>
            </div>
        </div>
        <div class="carriers-list">
            <div v-for="carrier in carriers" :key="carrier.id_carrier">
                <div class="row" v-if="isVisible(carrier)">
                    <div class="col">
                        <!--<input type="radio" :checked="selectedCarrier === carrier.id_carrier" name="delivery_option[]" :value="compatId(carrier)" />-->
                        <div class="carrier-line" @click="setCarrier(carrier)">
                             <div class="row">
                                 <div class="col-2 text-center">
                                     <span class="carrier-selector">
                                         <span class="carrier-selector-active" v-if="selectedCarrier === carrier.id_carrier"></span>
                                     </span>
                                 </div>
                                 <div class="col-2 col-md-1 carrier-image">
                                     <img :src="carrier.img" v-if="carrier.img">
                                 </div>
                                 <div class="col-8 col-xl-6 carrier-title">
                                     <p><strong>{{ carrier.name }}</strong></p>
                                     <p class="textSmaller">{{ carrier.delay }}</p>
                                     <p v-if="carrier.module === 'packetery'" class="packetery">
                                         <span v-if="packetery.id === null">
                                            <button @click="showPacketeryWidget(carrier)" class="packetery-button">
                                                {{ translations['Select packetery branch'] }}
                                            </button>
                                         </span>
                                         <span v-if="packetery.id !== null">
                                             <span class="packetery-branch-name">{{ packetery.name }}</span>
                                             <button @click="showPacketeryWidget(carrier)" class="packetery-button">{{ translations['change'] }}</button>
                                         </span>
                                     </p>
                                 </div>
                                 <div class="col-12 col-xl-3 text-right align-self-end align-self-lg-start carrier-price">
                                     <strong>{{ carrier.free ? translations['Free'] : carrier.formattedPrices.price }}</strong>
                                 </div>
                             </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
    import { mapState } from 'vuex'
    export default {
        computed: {
            ...mapState({
                translations: state => state.translations,
                carriers: state => state.carriers,
                selectedCarrier: state => state.selectedCarrier,
                packetery: state => state.packetery,
            }),
        },
        methods: {
            unsetCarrierAndPayment: function () {
                this.$store.dispatch('SELECT_CARRIER', null);
                this.$store.commit('SELECT_PAYMENT', null);
                this.$store.commit('SET_PACKETERY', {
                    id: null,
                    name: null,
                    currency: null
                })
            },
            setCarrier: function (carrier) {
                if (this.selectedCarrier === carrier.id_carrier) {
                    return;
                }
                const id = carrier.id_carrier;
                this.$store.dispatch('SELECT_CARRIER', id);
                if (carrier.module === 'packetery') {
                    this.showPacketeryWidget(carrier);
                }
            },
            isVisible: function (carrier) {
                if (this.selectedCarrier && this.selectedCarrier === carrier.id_carrier) {
                    return true
                }
                if (this.selectedCarrier === null) {
                    return true
                }
                return false
            },
            compatId: function (carrier) {
                return carrier.id_origin + ','
            },
            getPacketery: function () {
                const filtered = this.carriers.filter(item => item.module === 'packetery');
                if (filtered.length === 1) {
                    return filtered[0];
                }
                return null;
            },
            showPacketeryWidget: function (carrier) {
                Packeta.Widget.pick(carrier.extra.apiKey, (item) => {
                    if (item === null) {
                        return this.$store.commit('SET_PACKETERY', {
                            id: null,
                            name: null,
                            currency: null
                        })
                    }
                    this.$store.dispatch('UPDATE_PACKETERY', {
                        id: item.id,
                        name: item.name,
                        currency: item.currency
                    });
                })
            }
        },
        mounted() {
            const loadPacketeryScript = () => {
                if (this.carriers === null) {
                    setTimeout(loadPacketeryScript, 100)
                }
                if (this.getPacketery) {
                    const packeteryApi = document.createElement('script');
                    packeteryApi.setAttribute('src', 'https://widget.packeta.com/www/js/library.js');
                    document.head.appendChild(packeteryApi);
                }
            };

            loadPacketeryScript()
        }
    }
</script>
<style scoped lang="scss">
    .carriers {
        h3 {
            font-size: 24px;
            font-weight: 700;
            text-transform: uppercase;
        }

        .change-carrier {
            font-size: 14px;
            font-weight: 500;
            color: #f2b508;
            text-transform: lowercase;
            cursor: pointer;
        }

        .carriers-list {
            .carrier-line {
                border: 1px solid #f2f2f2;
                padding: 10px;
                margin-bottom: 10px;
                &.has-error {
                    border: 1px solid #da2626;
                }
                .carrier-selector {
                    width: 24px;
                    height: 24px;
                    border: 1px solid #afafaf;
                    border-radius: 12px;
                    display: inline-block;
                    padding: 6px;
                    margin-top: 6px;

                    .carrier-selector-active {
                        background-color: #f2b508;
                        border-radius: 10px;
                        display: inline-block;
                        height: 100%;
                        width: 100%;
                        vertical-align: top;
                        &:before {
                            content: " ";
                        }
                    }
                }
                .carrier-image {
                    padding: 0;
                    img {
                        width: 100%;
                    }
                }
                .carrier-title {
                    font-size: 14px;
                    font-weight: 400;
                    color: #999999;
                    strong {
                        color: #1a1a1a;
                        font-weight: 500;
                    }
                }
                .carrier-price {
                    font-size: 18px;
                    font-weight: 700;
                }

                .packetery {
                    .packetery-button {
                        border: 2px solid #f2b508;
                        background: #ffffff;
                        font-size: 0.8rem;
                        color: #1a1a1a;
                    }
                    .packetery-branch-name {
                        color: #1a1a1a;
                        font-size: 0.8rem;
                        margin-right: 0.4rem;
                    }
                }
            }
        }
    }
</style>
